import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
export type SbModalType = 'main' | 'aside' | 'dialog' | 'aside-left';
export type SbModalSize = 'normal' | 'large';
/** @deprecated - This component has been deprecated, check with Robert Hjalmers what to use instead */
@Component({
    selector: 'sb-modal',
    imports: [CommonModule, RouterModule],
    template: `
        <div class="sb-modal-container" [ngClass]="'sb-modal-' + type">
            <main
                class="sb-modal"
                [attr.role]="type === 'dialog' ? 'alertdialog' : 'dialog'"
                aria-modal="true"
                [class.sb-modal-large]="size === 'large'"
                [class.sb-modal-fullscreen]="fullscreen"
                *ngIf="type === 'main' || type === 'dialog'"
            >
                <!-- TODO: add aria-labelledby -->
                <div *ngTemplateOutlet="content"></div>
            </main>
            <aside
                [class.fullscreen]="fullscreen"
                [class.sb-modal-large]="size === 'large'"
                class="sb-modal"
                role="dialog"
                aria-modal="true"
                *ngIf="type === 'aside' || type === 'aside-left'"
            >
                <div *ngTemplateOutlet="content"></div>
            </aside>
            <ng-container *ngIf="showBackdrop">
                <a
                    *ngIf="type !== 'dialog'"
                    class="backdrop"
                    replaceUrl="true"
                    [routerLink]="['', { outlets: { modal: null } }]"
                ></a>
                <div *ngIf="type === 'dialog'" class="backdrop"></div>
            </ng-container>
        </div>
        <ng-template #content>
            <ng-content></ng-content>
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class SbModalComponent {
    get showBackdrop(): boolean {
        return this._showBackdrop;
    }
    get fullscreen(): boolean {
        return this._fullscreen;
    }
    @Input() set fullscreen(value: boolean) {
        this._fullscreen = value;
    }
    @Input() set showBackdrop(value: boolean | string) {
        this._showBackdrop = value !== 'false' && value !== false;
    }
    @Input() type: SbModalType = 'aside';
    @Input() size?: SbModalSize = 'normal';
    private _showBackdrop = true;
    private _fullscreen = false;
}
